export const toTitleCase = (text: string): string => {
    return text.split(' ')
        .map(word => word.trim())
        .map(word => {
            return word.charAt(0).toUpperCase() + word.substring(1, word.length);
        })
        .join(' ');
};